import { LanguageCode } from '@hazadapt-git/public-core-base'

export interface PrepCheckLimitReachedModalTextConfig {
    title: string
    blurbChunk1: string
    blurbChunk2: string
    benefitsTitle: string
    benefits: string[]
    privacyTitle: string
    privacyBlurb: string
    cta: string
}

export const prepCheckLimitReachedModalText: Map<
    LanguageCode,
    PrepCheckLimitReachedModalTextConfig
> = new Map<LanguageCode, PrepCheckLimitReachedModalTextConfig>([
    [
        LanguageCode.ENGLISH,
        {
            title: `Prep Checks Limit Reached`,
            blurbChunk1: `In Guest Mode, you can still review or finish the one you started.`,
            blurbChunk2: `Create a free HazID account to unlock more Prep Checks and save your progress.`,
            benefitsTitle: `Your HazID lets you:`,
            benefits: [
                `Save all your Prep Checks and track progress`,
                `Come back anytime, from any device`,
                `Get personalized steps to grow your readiness`,
            ],
            privacyTitle: `Your privacy is protected.`,
            privacyBlurb: `We never sell your data, and your responses are only used to help you and your community prepare.`,
            cta: 'Make HazID Account',
        },
    ],
    [
        LanguageCode.SPANISH,
        {
            title: `Límite de Prep Checks alcanzado`,
            blurbChunk1: `En el Modo Invitado, aún puedes revisar o terminar la que empezaste.`,
            blurbChunk2: `Crea una cuenta gratuita de HazID para desbloquear más Prep Checks y guardar tu progreso.`,
            benefitsTitle: `Tu HazID te permite:`,
            benefits: [
                `Guarda todas tus Prep Checks y sigue el progreso`,
                `Vuelve cuando quieras, desde cualquier dispositivo`,
                `Obtén pasos personalizados para aumentar tu preparación`,
            ],
            privacyTitle: `Tu privacidad está protegida.`,
            privacyBlurb: `Nunca vendemos tus datos, y tus respuestas solo se utilizan para ayudarte a ti y a tu comunidad a prepararse.`,
            cta: 'Crear cuenta HazID',
        },
    ],
    [
        LanguageCode.GERMAN,
        {
            title: `Prep Checks-Limit erreicht`,
            blurbChunk1: `Im Gastmodus kannst du das Spiel, das du begonnen hast, noch überprüfen oder beenden. `,
            blurbChunk2: `Erstelle ein kostenloses HazID-Konto, um mehr Prep Checks freizuschalten und deinen Fortschritt zu speichern.`,
            benefitsTitle: `Deine HazID erlaubt dir:`,
            benefits: [
                `Speichere alle deine Prep Checks und verfolge den Fortschritt`,
                `aus`,
                `Erhalten Sie personalisierte Schritte, um Ihre Bereitschaft zu steigern`,
            ],
            privacyTitle: `Deine Privatsphäre ist geschützt.`,
            privacyBlurb: `Wir verkaufen Ihre Daten nie, und Ihre Antworten dienen nur dazu, Ihnen und Ihrer Gemeinschaft bei der Vorbereitung zu helfen.`,
            cta: 'HazID-Konto erstellen',
        },
    ],
    [
        LanguageCode.FRENCH,
        {
            title: `Limite de Prep Checks atteinte`,
            blurbChunk1: `En mode invité, vous pouvez toujours relire ou terminer celui que vous avez commencé. `,
            blurbChunk2: `Créez un compte HazID gratuit pour débloquer davantage de Prep Checks et sauvegarder votre progression.`,
            benefitsTitle: `Votre HazID vous permet de :`,
            benefits: [
                `Sauvegardez tous vos Prep Checks et suivez vos progrès`,
                `Revenez à tout moment, depuis n’importe quel appareil`,
                `Obtenez des étapes personnalisées pour améliorer votre préparation`,
            ],
            privacyTitle: `Votre vie privée est protégée.`,
            privacyBlurb: `Nous ne vendons jamais vos données, et vos réponses sont uniquement utilisées pour vous aider, vous et votre communauté, à vous préparer.`,
            cta: 'Créer un compte HazID',
        },
    ],
    [
        LanguageCode.MANDARIN,
        {
            title: `Prep Checks限制已达`,
            blurbChunk1: `在访客模式下，你仍然可以复习或完成你开始的那个。`,
            blurbChunk2: `创建一个免费的HazID账户，解锁更多Prep Checks并保存你的进度。`,
            benefitsTitle: `你的HazID允许你：`,
            benefits: [
                `保存所有Prep Checks并跟踪进度`,
                `随时回来，任何设备`,
                `获取个性化步骤以提升你的准备度`,
            ],
            privacyTitle: `你的隐私受到保护。`,
            privacyBlurb: `我们从不出售您的数据，您的回复仅用于帮助您和社区做好准备。`,
            cta: '创建HazID账户',
        },
    ],
    [
        LanguageCode.RUSSIAN,
        {
            title: `Достигнут лимит Prep Checks`,
            blurbChunk1: `В гостевом режиме вы всё ещё можете повторить или завершить начатый вариант.`,
            blurbChunk2: `Создайте бесплатный аккаунт HazID, чтобы разблокировать дополнительные Prep Checks и сохранить прогресс.`,
            benefitsTitle: `Ваш HazID позволяет вам:`,
            benefits: [
                `Сохраняйте все Prep Checks и отслеживайте прогресс`,
                `Возвращайтесь в любое время, с любого устройства`,
                `Получите персонализированные шаги для повышения готовности`,
            ],
            privacyTitle: `Ваша приватность защищена.`,
            privacyBlurb: `Мы никогда не продаём ваши данные, а ваши ответы используются только для подготовки вас и вашего сообщества.`,
            cta: 'Создать аккаунт HazID',
        },
    ],
    [
        LanguageCode.JAPANESE,
        {
            title: `Prep Checksの上限に達しました`,
            blurbChunk1: `ゲストモードでは、始めたものをレビューしたりクリアしたりできます。`,
            blurbChunk2: `無料のHazIDアカウントを作成して、より多くのPrep Checksをアンロックし、進行状況を保存しましょう。`,
            benefitsTitle: `HazIDでは以下が可能です:`,
            benefits: [
                `すべてのPrep Checksを保存し、進捗を追跡しましょう`,
                ` いつでも、どんなデバイスからでも戻ってきてください`,
                `準備度を高めるための個別のステップを手に入れましょう`,
            ],
            privacyTitle: `あなたのプライバシーは守られています。`,
            privacyBlurb: `私たちはあなたのデータを決して販売せず、あなたの回答はあなたやコミュニティの準備のためだけに使われています。`,
            cta: 'HazIDアカウント作成',
        },
    ],
])
